import { AccountListItem as UIAccountListItem, type AccountListItemProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

const AccountListItem = (props: Omit<AccountListItemProps, 'accountIconAltText' | 'verificationInProgressText'>) => {
    const { t } = useTranslation()
    return (
        <UIAccountListItem
            {...props}
            accountIconAltText={t('components.accountListItem.accountIcon')}
            verificationInProgressText={t('components.accountListItem.verificationInProgress')}
        />
    )
}

export default AccountListItem
